//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FootButton from "../components/FooterBtn.vue";
import Catalog from "@/components/catalog.vue";


export default {
  name: "detail",
  components: {
    FootButton,
    Catalog
  },
  data() {
    return {
      show: false,
      loading: true,
      imgNone: require("@/assets/image/photo/p1.jpg"),
      pageData: "",
      columnId: "",
      paly: false,
      imgNull: require("@/assets/image/icon/icon_null.png"),
      errData:{
        code:false
      },
      curPlayIndex: -1,
      accessRegion: true,//true 为可以进行阅读，false说明ip为非可阅读区域ip
      isLogin: true,
      isDiscount: true
    };
  },
  created: function() {
    //console.log(this.CONFIG.GETSHARE);
  },
  methods: {
    goBuy() {
      if(this.SERVER.APPID == "orangenews"){
        if(this.isLogin){
          this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
        }else{
          this.$router.push({
            path: '/login'
          })
        }
      }else{
        if(this.isLogin){
          this.$routerHelper.goBuyPage(this.$router,this.columnId,"medialist")
        }else{
          this.$dialog.confirm({
            message: this.$t('AUDIOPLAYERDE_LANG.shwoDialogLogin.1'),
            confirmButtonText: this.$t('AUDIOPLAYERDE_LANG.shwoDialogLogin.2')
          }).then(() => {
            this.$router.push({
              path: '/login'
            })
          }).catch(() => { });
        }
      }

    },
    type(type) {
      this.paly = type;
      console.log(type);
    },
    getData() {
      //獲取詳情
      let mediaPost = {
        id: this.columnId
      };
      this.$toast.loading(); //doAxios
      this.GLOBAL_.ccRequest.doSessionAxios(this.CONFIG.MEDIA.COLUMN, mediaPost, "GET", "no login")
      .then(res => {
          // console.log(res);
          // res.items[2].canTry = 0;
          this.$toast.close();
          this.show = true;

          this.pageData = res;
          console.log('res',res);
          this.detailCoverUrl = this.pageData.detailCoverUrl;
          this.pageDataDetailCoverUrl = this.pageData.detailCoverUrl;

          //this.getAudioData(res.items); //音频列表
        }).catch(err => {
          console.log('eeeeee',err);
          console.log(err.response.data);
          this.show = true;
          this.$toast.close();
          if(err.response.data &&err.response.data.message){
              this.errData = err.response.data
          }
        console.log('errData',this.errData);
      });

    },
    //列表切换
    onChangeMediaData (data,index) {
      console.log(data);
    },
    //返回上一页
    onClickLeft(){
      this.$router.back()
    }
  },
  mounted: function() {
    this.columnId = this.$route.query.id;
    //let _audio = this.$refs.audio;
    this.getData();

    //判斷是否登錄
    this.LOGIN2.getSession("no login")
      .then(session => {
        this.isLogin = true;
      })
      .catch(err => {
        this.isLogin = false;
      });
  },
  beforeRouteEnter(to, from, next) {
    //console.log('to', to.path, to);
    next(vm => {
      if(from.path == '/list') {
        vm.isDiscount = false
      } else {
        vm.isDiscount = true
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/pages/detail.vue